const navigationItems = Array.from(document.querySelectorAll('.find-your-stage-navigation li'));
const questionSteps = Array.from(document.querySelectorAll('.find-your-stage-step'));


const hash = window.location.hash;
if (['#early', '#early-mid', '#mid-late', '#late'].includes(hash)) {
  const results = document.querySelector('.find-your-stage-results');

  navigationItems.forEach((item) => item.classList.add('active'));

  results.classList.add('active');
  let answer = '';
  switch (hash) {
    case '#early':
      answer = 'Early (4)'; break;
    case '#early-mid':
      answer = 'Early-Mid (3)'; break;
    case '#mid-late':
      answer = 'Mid-Late (2)'; break;
    case '#late':
      answer = 'Late (1)'; break;
  }
  document.querySelector('.find-your-stage-step.active').classList.remove('active');
  document.querySelector(`.find-your-stage-result[data-result="${answer}"]`).classList.add('active');
}

var old_element = document.querySelector('.find-your-stage-result form');
var new_element = old_element.cloneNode(true);
old_element.parentNode.replaceChild(new_element, old_element);

document.querySelector('.find-your-stage-result form').addEventListener('submit', function (e) {
  e.stopPropagation();
  e.preventDefault();

  const email = document.querySelector('input[name="contact[email]"]').value;
  const stage = document.querySelector('.find-your-stage-pre-results form').getAttribute('id');

  klaviyo.identify({
    'email': email,
    'Accepts Marketing': true
  }, function () {
    klaviyo.push(['track', 'Quiz Result', {
      'Stage': stage
    }]);
  });

  // Show results
  showResults();

  return false;
});

document.querySelector('.find-your-stage-questions').addEventListener('click', function (e) {
  if (
    e.target.matches('a[data-type="question-navigate"]') ||
    e.target.matches('a[data-type="question-navigate-next"]') ||
    e.target.matches('a[data-type="question-navigate-prev"]') ||
    e.target.matches('a[data-type="navigate-results"]')
  ) {
    e.preventDefault();


    const currentQuestion = e.target.closest('.find-your-stage-step');
    const navigateType = e.target.dataset.type;
    const nextQuestionRef = e.target.closest('a').getAttribute('href');
    const nextQuestion = document.querySelector(nextQuestionRef);
    if (navigateType === 'question-navigate-next') {
      const answeredQuestion = currentQuestion.querySelector('input:checked');
      const questionError = currentQuestion.querySelector('.question-error');
      if (!answeredQuestion) {
        questionError.classList.remove('hidden');
        return;
      }
      questionError.classList.add('hidden');
    }


    if (navigateType === 'question-navigate' || navigateType === 'question-navigate-next') {
      currentQuestion.classList.remove('active');
    }

    // get the index of nextQuestion
    const nextQuestionIndex = questionSteps.indexOf(nextQuestion);
    const activeNavigationItems = navigationItems.slice(0, nextQuestionIndex + 1);
    const preResults = document.querySelector('.find-your-stage-pre-results');

    if (navigateType === 'question-navigate-prev') {
      currentQuestion.classList.remove('active');
    }


    if (nextQuestion) {
      navigationItems.forEach((item) => item.classList.remove('active'));
      activeNavigationItems.forEach((item) => item.classList.add('active'));
      nextQuestion.classList.add('active');
    } else if (preResults && preResults.classList.contains('active') == false) {

      navigationItems.forEach((item) => item.classList.add('active'));
      preResults.classList.add('active');

      const answers = [...document.querySelectorAll('.find-your-stage-questions input:checked')].map((i) => i.value);
      // Get the most common answer
      const mostCommonAnswer = answers
        .sort((a, b) => answers.filter((v) => v === a).length - answers.filter((v) => v === b).length)
        .pop();

      const answerTag = mostCommonAnswer.split(' ')[0].toLowerCase();

      document.querySelector('input[name="contact[tags]"]').value = 'find-your-stage-' + answerTag;
      document.querySelector('.find-your-stage-pre-results form').setAttribute('id', answerTag);
      document.querySelector('.find-your-stage-pre-results form').setAttribute('action', '/contact#' + answerTag);

    } else {
      navigationItems.forEach((item) => item.classList.add('active'));

      const answers = [...document.querySelectorAll('.find-your-stage-questions input:checked')].map((i) => i.value);

      // Get the most common answer
      const mostCommonAnswer = answers
        .sort((a, b) => answers.filter((v) => v === a).length - answers.filter((v) => v === b).length)
        .pop();

      document.querySelector(`.find-your-stage-result[data-result="${mostCommonAnswer}"]`).classList.add('active');

      showResults();
    }
  }
});

function showResults() {
  const preResults = document.querySelector('.find-your-stage-pre-results');
  const results = document.querySelector('.find-your-stage-results');

  // Show results
  document.querySelector('.find-your-stage-questions').classList.add('hidden');
  if (preResults) {
    preResults.classList.remove('active');
  }
  results.classList.add('active');

  // Select all card-relish elements within the scrollable div
  const cardRelishes = document.querySelectorAll('.find-your-stage-result.active .scrollable .card-relish');
  const nextButton = document.querySelector('.find-your-stage-result.active .slider-button[name="next"]')
  const previousButton = document.querySelector('.find-your-stage-result.active .slider-button[name="previous"]')

  // Create a new IntersectionObserver instance
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      entry.target.classList.toggle('visible', entry.isIntersecting)
    });
    if (cardRelishes[0].classList.contains('visible')) {
      previousButton.setAttribute('disabled', 'disabled');
    } else {
      previousButton.removeAttribute('disabled');
    }

    if (cardRelishes[cardRelishes.length - 1].classList.contains('visible')) {
      nextButton.setAttribute('disabled', 'disabled');
    } else {
      nextButton.removeAttribute('disabled');
    }

  }, {
    root: document.querySelector('.find-your-stage-result.active .scrollable'), // The scrollable div
    rootMargin: '0px',
    threshold: 0.8 // Adjust the threshold as needed for more specific visibility
  });

  // Observe each card-relish element
  cardRelishes.forEach(card => observer.observe(card));
}


document.querySelector('.find-your-stage-results').addEventListener('click', function (event) {
  if (event.target.tagName === 'BUTTON' && event.target.classList.contains('slider-button')) {
    const stageButton = event.target;
    const scrollDirection = stageButton.getAttribute('name') === 'next' ? 'right' : 'left';

    const recomendedProductCards = [...event.target.closest('.product-grid').querySelectorAll('.card-relish')];
    if (scrollDirection === 'right') {
      recomendedProductCards.reverse();
    }
    for (var i = 0; i < recomendedProductCards.length; i++) {
      if (recomendedProductCards[i + 1].classList.contains('visible') === true) {
        recomendedProductCards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        break;
      }
    }
  }
});